import { User } from '../constants/dataTypes';
import { Company } from '../store/clients/types';

/**
 * generates break recipient data for client/company into fields for csv
 */
export default class CSVUtils {
  static GetCSVUserWithCompanyCellData = (
    user: User | undefined,
    company: Company | undefined,
  ) => {
    const cellDataParts = [
      user?.fields.given_name || '',
      user?.fields.family_name || '',
      company?.fields.name || '',
      user?.fields.email || '',
    ];

    return cellDataParts.join('","');
  };

  static GetCSVUserCellData = (user: User | undefined) => {
    const cellDataParts = [
      user?.fields.given_name || '',
      user?.fields.family_name || '',
      user?.fields.email || '',
    ];

    return cellDataParts.join('","');
  };

  // values that are used in CSV export for a user - first name, last name, and email
  static CSVUserHeaderColumns = 'First Name","Last Name","Email';

  // values that are used in CSV export for a user - first name, last name, company and email
  static CSVUserWithCompanyHeaderColumns =
    'First Name","Last Name","Company","Email';
}
